import { getQueryParam } from '../routing/getQueryParam';
import Url from 'urlinator/Url';
export const getOauthRedirect = () => {
  const loginRedirecturl = new Url(getQueryParam('loginRedirectUrl'));
  const {
    hostname,
    pathname
  } = loginRedirecturl;
  const {
    client_id,
    redirect_uri,
    scope,
    state
  } = loginRedirecturl.params;
  const redirectRoute = `https://${hostname}${pathname}`;
  const redirectUrl = new Url(redirectRoute);
  redirectUrl.pushParam('client_id', client_id);
  redirectUrl.pushParam('redirect_uri', redirect_uri);
  redirectUrl.pushParam('scope', scope);

  if (state) {
    redirectUrl.pushParam('state', state);
  }

  return redirectUrl.href;
};